import BaseViewController from "./base-view-controller";

class CarePlanDetailsViewController extends BaseViewController {
  handleButtonClick(name, text, action) {
    if (name === "schedule_a_visit_button") {
      this.appData.onExit("/care_option/primary_care_category");
      return;
    }
    super.handleButtonClick(name, text, action);
  }
}
export default CarePlanDetailsViewController;
